import $ from "jquery";
import axios from "axios";

class Gus {
    constructor() {
        this.name = '#b2b_company_name';
        this.nip = '#b2b_company_nip';
        this.address = '#b2b_company_street';
        this.city = '#b2b_company_city';
        this.postal = '#b2b_company_post_code';
        this.button = '#gusData';

        this.bindRequest();
    }

    bindRequest() {
        $(document).ready(() => {

            $(this.nip).on("keyup blur", (event) => {
                const element = $(event.currentTarget);
                const value = element.val();

                if (value.length >= 10 && !element.hasClass("error")) {
                    $(this.button).prop("disabled", false);
                } else {
                    $(this.button).prop("disabled", true);
                }
            });

            $(this.button).on('click', (event) => {
                event.preventDefault();
                const element = $(event.currentTarget);
                const nip = $(this.nip);

                nip.prop("disabled", true);

                element.addClass("button--loading").prop("disabled", true);

                axios.get(`/nip_check?nip=${nip.val()}`)
                    .then((response) => {
                        const data = response.data;

                        if (data) {
                            if (data.name) $(this.name).val(data.name);
                            if (data.address) $(this.address).val(data.address);
                            if (data.city) $(this.city).val(data.city);
                            if (data.postal) $(this.postal).val(data.postal);
                        }

                        element.removeClass("button--loading").prop("disabled", false);
                        nip.prop("disabled", false);

                    })
                    .catch((error) => console.error(error));
            });

        });
    }
}

export default new Gus();
